import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-edit-service',
  templateUrl: './edit-service.component.html',
  styleUrls: ['./edit-service.component.scss']
})
export class EditServiceComponent implements OnInit, OnDestroy {
  businessTypeData: any = [
    {
      title: "Business or Shop",
      value: '1',
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/business_type.png'
    },
    {
      title: "Individual professional",
      value: '2',
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/individual_type.png'
    }
  ]
  serviceTypeData: any = [
    {
      title: "Shop/In-premise",
      isSelected: false,
      assetUrl: '../../../../assets/images/business-creation-imgs/shop_type.png'
    },
    {
      title: "Home service",
      isSelected: false,
      assetUrl: '../../../../assets/images/business-creation-imgs/home_type.png'
    },
    {
      title: "Virtual",
      isSelected: false,
      assetUrl: '../../../../assets/images/business-creation-imgs/virtual_type.png'
    }
  ]
  professsionalGender: any = [
    {
      title: "Male professional",
      name: "male",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/male.png'
    },
    {
      title: "Female professional",
      name: "female",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/female.png'
    },
    {
      title: "Others",
      name: "others",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/unisex.png'
    }
  ]
  serviceTypeGender: any = [
    {
      id: 1,
      title: "Ladies",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/female.png'
    },
    {
      id: 2,
      title: "Gents",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/male.png'
    },
    {
      id: 3,
      title: "Unisex",
      isSelected: 0,
      assetUrl: '../../../../assets/images/business-creation-imgs/unisex.png'
    }
  ]
  apisub: Subscription
  selectedBusinessType: number = 0
  allServiceTemplateData: any = []
  toShowServiceTemplates: any = []
  constructor(private activemodal: MatDialogRef<EditServiceComponent>,private loaderservice: LoaderServiceService, private _apiService: ApiService, @Inject(MAT_DIALOG_DATA) public parentdata:any) {
    this.apisub = this._apiService.apiResult.subscribe(resData => {
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_SERVICE_TEMPLATES){ 
        this.allServiceTemplateData = []
        if(resData.result){
          this.allServiceTemplateData = resData.result
          this.allServiceTemplateData.forEach((element:any) => {
            element.isSelected = false
          });
          // this.businessTypeData[0].isSelected = 1
          this.businessTypeData[parentdata.entityDetails.entity_type - 1].isSelected = 1
          this.toShowServiceTemplates = this.allServiceTemplateData.filter((item:any) => item.entity_type == parentdata.entityDetails.entity_type)
          
          console.log(this.toShowServiceTemplates);
          console.log(parentdata.entityDetails.entity_services);
          

          this.toShowServiceTemplates.forEach((item:any) => {
            // Check if any element in mappingArray matches the current item's hash_id
            const match = parentdata.entityDetails.entity_services.find(
              (mapItem:any) => mapItem.template_hash === item.hash_id
            );
          
            // If a match is found, update the isSelected property
            if (match) {
              item.isSelected = true;
            }
          });
          const index = this.professsionalGender.findIndex((item:any) => item.name == parentdata.entityDetails.provider_gender )
          if(index != -1){

            this.professsionalGender[index].isSelected = 1  
            this.providerGender = this.professsionalGender[index].name 
          }

          if(parentdata.entityDetails.shopServiceStatus != 2){
            this.serviceTypeData[0].isSelected = true
          }
          if(parentdata.entityDetails.homeServiceStatus != 2){
            this.serviceTypeData[1].isSelected = true
          }
          if(parentdata.entityDetails.virtual_service_status != 2){
            this.serviceTypeData[2].isSelected = true
          }

          const index1 = this.serviceTypeGender.findIndex((item:any) => item.id == parentdata.entityDetails.service_target_type )
          if(index1 != -1){

            this.serviceTypeGender[index1].isSelected = 1
            this.serviceTargetType = this.serviceTypeGender[index1].id  
          }

          // if(parentdata.entityDetails.service_target_type == 1){
          //   this.serviceTypeGender[0].isSelected = 1
          //   this.serviceTargetType = this.serviceTypeGender[0].id
          // }
          // if(parentdata.entityDetails.service_target_type == 2){
          //   this.serviceTypeGender[1].isSelected = 1
          //   this.serviceTargetType = this.serviceTypeGender[1].id
          // }
          // if(parentdata.entityDetails.service_target_type == 3){
          //   this.serviceTypeGender[2].isSelected = 1
          //   this.serviceTargetType = this.serviceTypeGender[2].id
          // }

          }
          this.loaderservice.showLoader = false
          this.loader = false
       }
       if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SERVICES){
        if(resData.result){
          this.loaderservice.showLoader = false
          this.activemodal.close({msg:'success'})
        }
       }
    })
   }
  loader: boolean = false
  ngOnInit(): void {
    this.loader = true
      this.loaderservice.showLoader = true
      this._apiService.getEntityServiceTemplates()  
  }
  changeBusinessType(event: any, index:any){

    this.allServiceTemplateData.forEach((element:any) => {
      element.isSelected = false
    });
    this.businessTypeData.forEach((element:any) => {
      element.isSelected = 0
    });
    this.professsionalGender.forEach((element:any) => {
      element.isSelected = 0
    });

    this.businessTypeData[index].isSelected = 1
    if(index == 0){
      this.toShowServiceTemplates = this.allServiceTemplateData.filter((item:any) => item.entity_type == 1)

    }
    else{
      this.toShowServiceTemplates = this.allServiceTemplateData.filter((item:any) => item.entity_type == 2)
    }

    this.toShowServiceTemplates.forEach((item:any) => {
      // Check if any element in mappingArray matches the current item's hash_id
      const match = this.parentdata.entityDetails.entity_services.find(
        (mapItem:any) => mapItem.template_hash === item.hash_id
      );
    
      // If a match is found, update the isSelected property
      if (match) {
        item.isSelected = true;
      }
    });

    const index1 = this.professsionalGender.findIndex((item:any) => item.name == this.parentdata.entityDetails.provider_gender )
    if(index1 != -1){
      this.professsionalGender[index1].isSelected = 1  

    }

console.log(this.toShowServiceTemplates);

  }
  selectServiceTemplate(event: any, index:any){
      this.toShowServiceTemplates[index].isSelected = event.checked
  }

  selectServiceTypeData(event: any,index:any){
     this.serviceTypeData[index].isSelected = event.checked
  }

  providerGender:any = null
  selectProfessionalGender(index:any){
    this.professsionalGender.forEach((element:any) => {
      element.isSelected = 0
    });

    this.professsionalGender[index].isSelected = 1
    this.providerGender = this.professsionalGender[index].name
    
  }

  serviceTargetType:any
  selectServiceTypeGender(index:any){
    this.serviceTypeGender.forEach((element:any) => {
      element.isSelected = 0
    });

    this.serviceTypeGender[index].isSelected = 1
    this.serviceTargetType = this.serviceTypeGender[index].id

  }

  onSave(){
    let r_mode = this.toShowServiceTemplates.filter((item:any) => item.isSelected == 1 || item.isSelected)
    let newSelectedServices:any[] = []   
    let deletedServices:any[] = []   
    this.allServiceTemplateData.forEach((item:any) => {
      // Check if any element in mappingArray matches the current item's hash_id
      const match = this.parentdata.entityDetails.entity_services.find(
        (mapItem:any) => mapItem.template_hash === item.hash_id
      );
    
      // If a match is found, update the isSelected property

      
      if (match) {
        if(item.isSelected == 1){

        }else{
          deletedServices.push(match)
        }
        
      }
      else{
        if(item.isSelected == 1){
          newSelectedServices.push(item)
        }else{
        }
        
      }
    });
    console.log("new:::::::::::::", newSelectedServices);
    console.log("deleted:::::::::::::", deletedServices);
    
    let obj = {
          entity_hash: this.parentdata.entityDetails.hashId,
          entity_type: this.businessTypeData[0].isSelected == 1 ? 1 : 2,
          individual_gender: this.businessTypeData[1].isSelected == 1 ? this.providerGender : null,
          service_target_type: this.serviceTargetType,
          delete_services: deletedServices.map((item:any) => { return item.service_hash }),
          services: newSelectedServices.map((item:any) => {return item.hash_id}),
          // home_service_status: this.serviceTypeData[1].isSelected || this.serviceTypeData[1].isSelected == 1 ? 0 : 2,
          home_service_status: this.parentdata.entityDetails.homeServiceStatus == 0 || this.parentdata.entityDetails.homeServiceStatus == 1 ? (this.serviceTypeData[1].isSelected ? this.parentdata.entityDetails.homeServiceStatus : 2) : this.serviceTypeData[1].isSelected ? 0 : this.parentdata.entityDetails.homeServiceStatus,
          // shop_service_status: this.serviceTypeData[0].isSelected || this.serviceTypeData[0].isSelected == 1 ? 0 : 2,
          shop_service_status: this.parentdata.entityDetails.shopServiceStatus == 0 || this.parentdata.entityDetails.shopServiceStatus == 1 ? (this.serviceTypeData[0].isSelected ? this.parentdata.entityDetails.shopServiceStatus : 2) : this.serviceTypeData[0].isSelected ? 0 : this.parentdata.entityDetails.shopServiceStatus,
          // virtual_service_status: this.serviceTypeData[2].isSelected || this.serviceTypeData[2].isSelected == 1 ? 0 : 2
          virtual_service_status: this.parentdata.entityDetails.virtual_service_status == 0 || this.parentdata.entityDetails.virtual_service_status == 1 ? (this.serviceTypeData[2].isSelected ? this.parentdata.entityDetails.virtual_service_status : 2) : this.serviceTypeData[2].isSelected ? 0 : this.parentdata.entityDetails.virtual_service_status,
          revenue_mode: r_mode[0].revenue_mode
    }
    console.log(obj);
    this.loaderservice.showLoader = true
    this._apiService.updateEntityServices(obj)
    
  }

// form checker

checkServicesSelected(){

  const index = this.toShowServiceTemplates.findIndex((item:any) => item.isSelected == true || item.isSelected == 1 ) 

  
  if(index != -1){
    return false
  }else{
    return true
  }
  
}
isGenderSelected(){
  if(this.businessTypeData[1].isSelected == 1){
    const index = this.professsionalGender.findIndex((item:any) => item.isSelected == 1)
    if(index != -1){
      return false
    }else{
      return true
    }
  }
  else{
    return false
  }
}

checkServiceTypeSelected(){
  const index = this.serviceTypeData.findIndex((item:any) => item.isSelected == true || item.isSelected == 1 ) 

  
  if(index != -1){
    return false
  }else{
    return true
  }
}
checkServiceTargetTypeSelected(){
  const index = this.serviceTypeGender.findIndex((item:any) => item.isSelected == 1 ) 

  
  if(index != -1){
    return false
  }else{
    return true
  }
}

checkDisabilityForCheckBox(item:any){
  
  //if regular service
  if(item.revenue_mode == 1){
    const index = this.toShowServiceTemplates.findIndex((item:any) => item.revenue_mode == 2 && item.isSelected)
    // if a subscription service is checked
    if(index != -1){
      return true
    }
      return false
  }
  // if subscription service
  else if(item.revenue_mode == 2){
    const index = this.toShowServiceTemplates.findIndex((item:any) => item.revenue_mode == 1 && item.isSelected)
    // if a regular service is checked
    if(index != -1){
      return true
    }
      return false
  }
  return false
}


  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
